import React from 'react';
import postman1 from '../../../../../../images/postman1.png';
import postman2 from '../../../../../../images/postman2.png';


const Info5 = () => {
    return (
        <div style={{
            fontFamily: 'Gilroy-Light',
            lineHeight: 1.6,
            overflowX: 'auto',
            width: '100%',
            maxWidth: '100vw',  // ekranın genişliğini aşmasın
            boxSizing: 'border-box',
            padding: '0px 16px',
        }}>
            <h2 style={{ marginTop: 0 }}><strong>Postman Collection</strong></h2>

            <p>
                If you want to easily experience the <strong>Albaraka APIs</strong> in Postman,
                simply download the following Postman collection file and import it into the Postman environment.
            </p>

            <p>
                👉  <a
                    href="/albaraka-api-collection.json"
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Download Postman Collection File 
                </a>
            </p>

            <p>
                After downloading the file, click the <strong>Import</strong> button in Postman.
            </p>

            <img
                src={postman1}
                alt="Postman Import Step 1"
                style={{ maxWidth: '100%', margin: '20px 0' }}
            />

            <p>
                Drag and drop the file as shown below. The <strong>Albaraka API Collection</strong> will be automatically added
                to your Postman collections.
            </p>

            <img
                src={postman2}
                alt="Postman Import Step 2"
                style={{ maxWidth: '100%', margin: '20px 0' }}
            />
        </div>
    );
};

export default Info5;
